
























































import draggable from "vuedraggable";
import { Mixins } from "vue-mixin-decorator";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IPagination, ISelectItem } from "@/types";
import { ICostIndexListRequest, ICostIndex } from "@/types/cost_index";
import { IPartnerListRequest } from "@/types/partner";
import Search from "@/components/admin/forms/Search.vue";
import GeneralMixin from "@/mixin";
import DataTableRowHandler from "@/components/DatatableRowHandler.vue";

@Component({
  components: { Search, DataTableRowHandler, draggable }
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("cost_index/adminGetList")
  public adminGetList!: (params: ICostIndexListRequest) => void;

  @Action("partner/adminGetList")
  public adminGetPartnerList!: (params: IPartnerListRequest) => void;

  @Action("cost_index/sort")
  public sort!: (data: {
    costIndexId: number;
    newIndex: number;
  }) => Promise<boolean>;

  @Getter("partner/selectItem")
  public partners!: ISelectItem[];

  @Getter("cost_index/pagination")
  public pagination!: IPagination<ICostIndex[]>;

  @Getter("cost_index/list")
  public list!: ICostIndex[];

  @Mutation("cost_index/clear")
  public clear!: () => void;

  @Prop({ default: 0 })
  public fixed_partner_id!: number;

  @Watch("$route.query")
  public async changeQuery() {
    this.queryToParams();
    await this.adminGetList(this.params);
  }

  //
  // variables
  //
  public partner_id = 0;
  public headers = [
    { text: "表示順移動", value: "knob", sortable: false },
    { text: "取引内容", value: "name", sortable: false },
    { text: "金額", value: "value", sortable: false },
    { text: "Actions", value: "actions", sortable: false }
  ];
  public params: ICostIndexListRequest = {
    search: "",
    partner_id: 0,
    page: 1,
    per_page: 0
  };
  public selectedItem!: ICostIndex;

  //
  // methods
  //
  //--------
  // 作成時に実行
  public async created() {
    this.partner_id = Number(this.$route.params.partner_id);
    this.clear();
    this.queryToParams();

    if (this.fixed_partner_id) {
      this.params.partner_id = this.fixed_partner_id;
    } else {
      this.headers.push({
        text: "外注先名",
        value: "partner.name",
        sortable: false
      });
    }
    await Promise.all([
      this.adminGetList(this.params),
      this.adminGetPartnerList({ per_page: 0 })
    ]);
  }

  // urlからパラメータをセットする
  // $router -> params
  private queryToParams() {
    const query = this.$route.query;
    this.params = {
      search: query.search ? decodeURI(query.search as string) : "",
      partner_id: query.partner_id ? Number(query.partner_id) : 0,
      page: query.page ? Number(query.page) : 1,
      per_page: 0
    };
  }

  // 1ページ目から検索
  // 主に検索条件が変更されたときに利用
  public async searchFirst() {
    this.params.page = 1;
    await this.paramsToQuery();
  }

  // URLのパラメータをセットする
  // params -> $router
  private paramsToQuery() {
    this.$router
      .push({
        path: this.$router.currentRoute.path,
        query: {
          search: this.params.search,
          partner_id: this.params.partner_id
            ? String(this.params.partner_id)
            : "",
          page: this.params.page ? String(this.params.page) : "1"
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch(() => {});
  }

  public editItem(cost_index: ICostIndex) {
    this.$router.push(`/admin/cost_index/${cost_index.id}/edit`);
  }

  public onMoveCallback(evt: { draggedContext: { element: ICostIndex } }) {
    const item = evt.draggedContext.element;
    this.selectedItem = item;

    return true;
  }

  public async onDropCallback(evt: { newIndex: number }) {
    await this.sort({
      costIndexId: this.selectedItem.id,
      newIndex: evt.newIndex
    });
  }
}
